/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  global-require,
  import/no-extraneous-dependencies
*/
if (!global._babelPolyfill) {
  require('@babel/polyfill');
}

// This allows the React dev tools to work through an iframe. This must run
// before React loads.
if (process.env.NODE_ENV === 'development' && window.parent !== window) {
  try {
    window.__REACT_DEVTOOLS_GLOBAL_HOOK__ = window.parent.__REACT_DEVTOOLS_GLOBAL_HOOK__;
  } catch (e) {
    // Ignore blocked origin DOMException.
  }
}
require('intl');
require('isomorphic-fetch');
require('./element-closest');

if (process.env.NODE_ENV === 'development') {
  // This is a debugging tool that's useful in development. I'm tired of having
  // to add an import to use it only to remove it again before I commit.
  // TypeScript and ESLint are unaware of this global variable, so if it ever
  // gets left in it won't build.
  window.getObjectTag = require('common/utils/get-object-tag');
}

// For custom Yup validation messages, Yup needs `setLocale` to happen
// before any schemas can be defined. All overwritten messages are contained
// in the following file.
require('hellospa/components/error-message/index');

// Replacing Object.fromEntries for older browsers
// since it was added with ECMAScript 2021 and isn't
// supported in IE 11, Firefox 56 and older
if (!Object.fromEntries) {
  Object.fromEntries = (arr) => arr.reduce((obj, [key, value]) => {
    obj[key] = value;
    return obj;
  }, {});
}
